var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgG100(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.218 9.73951C19.218 4.64844 15.0909 0.521324 9.9998 0.521324C4.90873 0.521324 0.781616 4.64844 0.781616 9.73951C0.781616 14.3406 4.15257 18.1542 8.55946 18.8457V12.4041H6.2189V9.73951H8.55946V7.70863C8.55946 5.39832 9.93567 4.12218 12.0413 4.12218C13.0498 4.12218 14.1048 4.30222 14.1048 4.30222V6.57076H12.9424C11.7973 6.57076 11.4401 7.28133 11.4401 8.01032V9.73951H13.9967L13.588 12.4041H11.4401V18.8457C15.847 18.1542 19.218 14.3406 19.218 9.73951Z",
    fill: "#AD2624"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5883 12.4035L13.997 9.73885H11.4404V8.00966C11.4404 7.28067 11.7975 6.5701 12.9426 6.5701H14.105V4.30156C14.105 4.30156 13.0501 4.12152 12.0415 4.12152C9.93588 4.12152 8.55967 5.39766 8.55967 7.70797V9.73885H6.21912V12.4035H8.55967V18.845C9.02899 18.9187 9.51001 18.957 10 18.957C10.49 18.957 10.971 18.9187 11.4404 18.845V12.4035H13.5883Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG100);
export default __webpack_public_path__ + "static/media/g-100.1b57dc31df9a8a8b9731262db9a92140.svg";
export { ForwardRef as ReactComponent };